import React, { JSX, PropsWithChildren } from 'react';
import { ButtonProps, LinkProps } from '../../../../types/HtmlProps';

export type ContextMenuButtonProps = PropsWithChildren<ButtonProps>;

export type ContextMenuLinkProps = PropsWithChildren<LinkProps>;

function isLink(props: ContextMenuLinkProps | ContextMenuButtonProps): props is ContextMenuLinkProps {
  return !!(props as ContextMenuLinkProps).href;
}

export function ContextMenuButton(props: ContextMenuButtonProps): JSX.Element;
export function ContextMenuButton(props: ContextMenuLinkProps): JSX.Element;
export function ContextMenuButton(props: ContextMenuLinkProps | ContextMenuButtonProps): JSX.Element {
  return isLink(props)
    ? (
  // eslint-disable-next-line jsx-a11y/anchor-has-content -- children are provided via spreading
        <a {...props} className="context-menu__button" />
      )
    : (
        <button {...props} type="button" className="context-menu__button" />
      );
}
